import React, { FC, memo } from 'react';

import cn from 'classnames';

import { FormikCustomField as CustomField } from 'src/components';
import styles from './WorkspaceFields.module.scss';
import { TFieldOption } from 'src/interfaces/WorkspacesTypes';

type TTextInputProps = {
  fileds: TFieldOption[];
  size?: 'sm' | 'md';
};

const TextInput: FC<TTextInputProps> = memo(({ size = 'md', fileds }) => {
  return (
    <>
      {fileds.map((field) => (
        <React.Fragment key={field.name}>
          {field.disabled ? (
            <div className={styles.disabledFieldWrapper}>
              <p className={cn(styles.fieldLabelClass, { [styles.fieldLabelSm]: size === 'sm' })}>{field.label}</p>
              <p className={styles.fieldLabelDisabled}>{field.inputValue || ''}</p>
            </div>
          ) : (
            <div className={styles.fieldContainer}>
              <CustomField
                label={field.label}
                id={field.name}
                name={field.name}
                placeholder={field.placeholder}
                classes={{
                  inputClassName: cn(styles.inputClass, { [styles.inputClassSm]: size === 'sm' }),
                  labelClassName: cn(styles.fieldLabelClass, { [styles.fieldLabelSm]: size === 'sm' }),
                  wrapperClassName: styles.wrapperClass,
                  errorClass: styles.errorClass
                }}
              />
            </div>
          )}
        </React.Fragment>
      ))}
    </>
  );
});

TextInput.displayName = 'TextInput';

export default TextInput;
